import { memo } from 'react';
import { Box, Skeleton } from '@betty/moonlight';
import {
  SKELETON_CATEGORY_IDS,
  SKELETON_GAME_IDS,
} from './CategoriesSkeleton.content';

function CategoriesSkeleton() {
  return SKELETON_CATEGORY_IDS.map((id) => (
    <Box key={id} marginHorizontal="space-400" marginVertical="space-300">
      <Skeleton width={96} height={24} marginBottom="space-300" />
      <Box flexDirection="row" paddingVertical="space-300">
        {SKELETON_GAME_IDS.map((id) => (
          <Skeleton key={id} width={108} height={108} marginRight="space-400" />
        ))}
      </Box>
    </Box>
  ));
}

export default memo(CategoriesSkeleton);
